import styled from '@emotion/styled'
import { themeColor, stylesIf } from 'utils/styles'
import { Row, Icon } from 'components/patterns'
import DaimlerLogoSvg from 'components/Footer/DaimlerLogoSvg'

const TemplateModeSelectButton = styled.div(
  (props) => `
    border-radius: 8px;
    width: 250px;
    height: 250px;
    padding: 84px 57.8px 88.2px 57px;
    flex-grow: 0;
    border: solid 1px ${themeColor('greyPrimary', props)};
    background-color: ${themeColor('whitePrimary', props)};
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    transition: all 0.1s ease-in-out;

    &:hover {
      cursor: pointer;
      background:  ${themeColor('blueLight', props)};
    }
    ${stylesIf(
      props.disabled,
      `
      border: solid 1px  ${themeColor('grey', props)};
      background-color: ${themeColor('greySecondary', props)};
      pointer-events: none;
    `
    )}
`
)

export const ApplyDaimlerTemplateWrapper = styled(TemplateModeSelectButton)()

export const ApplyDaimlerTemplateTitle = styled.div((props) => {
  const { disabled } = props
  return `
  width: 163px;
  height: 22px;

  font-family: Arial;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  position: absolute;
  bottom: 86.2px;
  color: ${themeColor('blackPrimary', props)};
  ${stylesIf(
    disabled,
    `
    color: ${themeColor('greyPrimary', props)};    
  `
  )}
`
})

export const ApplyCustomTemplateWrapper = styled(TemplateModeSelectButton)()

export const ApplyCustomTemplateTitle = styled.div((props) => {
  const { disabled } = props
  return `
  width: 133px;

  font-family: Arial;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  position: absolute;
  bottom: 86.2px;
  color: ${themeColor('blackPrimary', props)};
  ${stylesIf(
    disabled,
    `
    color: ${themeColor('greyPrimary', props)};
  `
  )}
`
})

export const CreateNewTemplateWrapper = styled(TemplateModeSelectButton)(
  (props) => `
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='${themeColor(
    'greyPrimary',
    props
  )}' stroke-width='1' stroke-dasharray='15' stroke-dashoffset='0' stroke-linecap='round'/%3e%3c/svg%3e");
  box-sizing: border-box;
  border-style: hidden;
  &:hover { border-style: solid; }

  > h2 {
    font-family: Arial;
    font-style: normal;
    font-weight: bold;
    font-size: 70px;
    color: ${themeColor('bluePrimary', props)};
    height: 40px;
    position: absolute;
    bottom: 115px;
  }

  > div {
    width: inherit;
    height: 22px;

    font-family: Arial;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 22px;
    text-align: center;
    color: ${themeColor('blackPrimary')};
    position: absolute;
    bottom: 86.2px;
  };
  `
)

export const PageTitleWrapper = styled.div`
  width: 100%;
  height: 24px;
  margin: 45px 0 8px 0px;
  font-family: Arial;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 24px;
  letter-spacing: normal;
  text-align: center;
  color: ${themeColor('blackPrimary')};
`

export const PageNoteWrapper = styled.div`
  width: 100%;
  height: 18px;
  font-family: Arial;
  font-size: 14px;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.29em;
  letter-spacing: normal;
  text-align: center;
  color: ${themeColor('blackPrimary')};
`

export const AlertContainer = styled.div(
  (props) => `
    background-color: ${themeColor('offWhite', props)};
    padding: 9px;
    padding-bottom: 1px;
  `
)

export const ViewWrapper = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  margin-top: 5px;
  margin-bottom: 68px;
  width: auto;
  background: ${themeColor('modalGrey')};
`

export const ApplyTemplateWrapper = styled.div`
  margin-top: 25px;
  margin-left: 50px;
  margin-right: 50px;
  display: flex;
  justify-content: center;
  gap: 25px;
`

export const ApplyTemplateFooter = styled.div`
  width: 100%;
  border-top: 1px solid ${themeColor('grey')};
  position: fixed;
  bottom: 0;
  padding-top: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
  background: ${themeColor('whitePrimary')};
  text-align: center;
  height: 68px;
`

export const BottomContainer = styled(Row)`
  margin-bottom: 100px;
`

export const CustomTemplateIcon = styled(Icon)((props) => {
  const { disabled } = props

  return `
  &&& {
    height: 50px;
    width: 50px;

    > path {
      fill: ${themeColor('bluePrimary', props)};
      ${stylesIf(
        disabled,
        `
        fill: ${themeColor('greyPrimary', props)};
      `
      )}
    }
  }
`
})

export const CustomTemplateIconWrapper = styled.div`
  bottom: 115px;
  position: absolute;
`

export const DaimlerLogoWrapper = styled.div`
  bottom: 115px;
  position: absolute;
`

export const StyledDaimlerLogoSvg = styled(DaimlerLogoSvg)((props) => {
  const { disabled } = props

  return `
  &&& {
    height: 15px;
    width: 150px;

    > path {
      fill-opacity: 1;
      fill:${themeColor('bluePrimary', props)};
      ${stylesIf(
        disabled,
        `
        fill: ${themeColor('greyPrimary', props)};   
      `
      )}
    }
  }
`
})
